import { getEnv } from '@xbcb/ui-utils';
import { UiStage } from '@xbcb/ui-types';
import { TagKey } from '@xbcb/shared-types';
import { CurrentUser } from 'libs/hooks/useCurrentUser';

const CBMS_CLASSIFICATION_SME_TAG_VALUE = 'CbmsClassificationSme';

export const isClassificationSmeUser = (currentUser: CurrentUser): boolean => {
  const { businessSupportTeams } = currentUser;

  if (
    businessSupportTeams?.nodes?.some(
      ({ tags }: { tags?: { key: string; value: string }[] }) =>
        tags?.some(
          ({ key, value }) =>
            key === TagKey.STRATEGIC_BUSINESS_UNIT &&
            value === CBMS_CLASSIFICATION_SME_TAG_VALUE,
        ),
    )
  ) {
    return true;
  }

  // Non-prod fallback: allow all operators until BST is tagged in prod
  const { stage } = getEnv();
  if (stage !== UiStage.PROD) {
    return true;
  }

  return false;
};
